import { useSiteLocale } from '../../hooks/useLocalizedNavigate';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../hooks/translations/TranslationProvider';
import { Facebook } from 'react-feather';
import { withSiteLocale } from '../../utils/helpers';
import { useAppSelector } from '../../store/hooks';

import './footer.css';

const Footer = () => {
    const auth = useAppSelector(state => state.auth);
    const { t } = useTranslation();
    const locale = useSiteLocale();
    const isAuthenticated = !!auth.authData;

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div>
                        <div className="footer-brand">Sportwice</div>
                        <p className="footer-description">
                            {t('footer.subtitle')}
                        </p>
                        <div className="footer-social">
                            <a
                                href="https://www.facebook.com/sportwiceofficial"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Facebook"
                            >
                                <Facebook size={18} />
                            </a>

                            <a
                                href="https://x.com/sportwice"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="X"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    color="white"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="white"
                                        d="M18.9,1.2h3.7l-8,9.2L24,22.9h-7.4l-5.8-7.6l-6.6,7.6H0.5l8.6-9.8L0,1.2h7.6l5.2,6.9L18.9,1.2z M17.6,20.7h2L6.5,3.3H4.3 L17.6,20.7z"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                    <div>
                        <h4 className="footer-title">{t('footer.product')}</h4>
                        <ul className="footer-links">
                            <Link
                                to={
                                    isAuthenticated
                                        ? `/${locale}/home`
                                        : withSiteLocale('/', locale)
                                }
                            >
                                <li className="footer-link">
                                    <p>Home</p>
                                </li>
                            </Link>
                        </ul>
                    </div>
                    <div>
                        <h4 className="footer-title">{t('footer.company')}</h4>
                        <ul className="footer-links">
                            {/* <Link to="/">
                                <li className="footer-link">
                                    <p>About</p>
                                </li>
                            </Link> */}
                            <Link to={withSiteLocale('/contact-us', locale)}>
                                <li className="footer-link">
                                    <p>{t('common.contact')}</p>
                                </li>
                            </Link>
                        </ul>
                    </div>
                    <div>
                        <h4 className="footer-title">{t('footer.legal')}</h4>
                        <ul className="footer-links">
                            <Link to={withSiteLocale('/terms', locale)}>
                                <li className="footer-link">
                                    <p>{t('footer.privacyAndTerms')}</p>
                                </li>
                            </Link>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    © 2026 Sportwice. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
